import { lazy } from 'react'
import { useSelector } from 'react-redux'

import { getStoreFormats } from '@/store/app'

import styles from './Main.module.scss'

const TopPage = lazy(() => import('@/components/TopPage/TopPage'))
const About = lazy(() => import('@/components/About/About'))
const Differences = lazy(() => import('@/components/Differences/Differences'))
const Formats = lazy(() => import('@/components/Formats/Formats'))
const Engraving = lazy(() => import('@/components/Engraving/Engraving'))
const Corporate = lazy(() => import('@/components/Corporate/Corporate'))
const PriceDetails = lazy(() => import('@/components/PriceDetails/PriceDetails'))
const Map = lazy(() => import('@/components/Map/Map'))
const Steps = lazy(() => import('@/components/Steps/Steps'))
const Partners = lazy(() => import('@/components/Partners/Partners'))
const Footer = lazy(() => import('@/components/Footer/Footer'))

function Main() {
  const formats = useSelector(getStoreFormats)
  const isFormats = formats?.length > 0

  return (
    <>
      <TopPage />

      <div className={styles.bgGraffiti}>
        <About />

        <div className={isFormats ? styles.bgBlackWall : ''}>
          <Differences />
          <Formats />
        </div>

        <Corporate />
        <Engraving />
        <PriceDetails />
        <Map />
        <Steps />
        <Partners />
        <Footer />
      </div>
    </>
  )
}

export default Main
